<template>
  <aside :class="wrapperClasses">
    <ul class="icon-list">
      <li v-for="(item, index) in items" :key="itemKey(item, index)">
        <span :class="itemClasses(item)"></span>
        <span class="label" v-html="item.html"></span>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "IconLst",
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    wrapperClasses() {
      let cls = ["plain-list", "num-items-" + this.items.length];
      return cls;
    }
  },
  methods: {
    itemKey(item, index) {
      return item.icon + "-" + index;
    },
    itemClasses(item) {
      let cls = ["icon", "icon-" + item.icon];
      return cls;
    }
  }
};
</script>
